export default "__VITE_ASSET__DfCEBAp1__"